<template>
    <div>
        <slider :drawer="drawer" @update="updateDrawer"></slider>
        <v-app-bar>
            <logo></logo>

            <organization-selector
                v-if="IsAuthenticated && HasUser && LinksLoadedAuth">
            </organization-selector>

            <v-spacer></v-spacer>

            <!-- <nav-menu class="hidden-md-and-down"></nav-menu> -->

			<router-link
            class="home"
            :to="{name: 'dashboard'}" exact>
				<v-icon>mdi-home</v-icon>
			</router-link>

            <!-- <profile></profile> -->

            <v-app-bar-nav-icon @click.stop="drawer = !drawer">
            </v-app-bar-nav-icon>
        </v-app-bar>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import namespace from '../store/namespace';
// import NavMenu from './Menu.vue';
import Logo from './Logo.vue';
import Slider from './Slider.vue';
// import Profile from './Profile.vue';
import OrganizationSelector from './OrganizationSelector.vue';

export default {
	name: 'NavToolbar',
	components: {
		// NavMenu,
		Logo,
		// Profile,
		OrganizationSelector,
		Slider,
	},
	data() {
		return {
			drawer: false,
		};
	},
	computed: {
		...mapGetters(namespace.USER, ['HasUser']),
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(['LinksLoaded', 'LinksLoadedAuth']),
	},
	methods: {
		updateDrawer(value) {
			this.drawer = value;
		},
	},
};
</script>

<style lang="scss" scoped>
a {
	text-decoration: none;
}

</style>
